import * as React from 'react';
import { disambiguatedPath } from '../findings-display-model';
import s from '../findings.module.scss';

export function GroupCategoryMix({
  items,
}: {
  items: Array<{ category: string; label: string; count: number }>;
}) {
  if (items.length === 0) return null;
  return (
    <span className={s.groupCategoryMix}>
      {items.map((item) => (
        <span key={item.category} className={s.groupCategoryMixItem}>
          <span className={s.groupCategoryDot} />
          <span>
            {item.count} {item.label}
          </span>
        </span>
      ))}
    </span>
  );
}

export function GroupTopFiles({
  files,
}: {
  files: Array<{ filePath: string; count: number }>;
}) {
  if (files.length === 0) return null;
  return (
    <span className={s.groupMixLine}>
      {files.map((file) => (
        <span key={file.filePath} className={s.groupMixItem}>
          <span title={file.filePath}>{disambiguatedPath(file.filePath)}</span>
          <strong>{file.count}</strong>
        </span>
      ))}
    </span>
  );
}
